(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hfb-ingredient-ritual"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    const carousel = event.target;
    if (!carousel.matches('.hfb-ritual__ingredients') || !['ArrowLeft', 'ArrowRight'].includes(event.key) || carousel.scrollWidth <= carousel.clientWidth) return;
    event.preventDefault();
    const card = carousel.querySelector('.hfb-ritual__card');
    const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(carousel).gap);
    carousel.scrollBy({ left: event.key === 'ArrowRight' ? distance : -distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
